export enum CVA_AUTH_MODULES {
  CVA_APPOINTMENT = 'cva-appointment',
  CVA_CONFIGURATION = 'cva-configuration',
  CVA_SOAP_NOTES = 'cva-soap-notes',
  CVA_ALLERGY = 'cva-allergy',
  CVA_OBSERVATION = 'cva-observation',
  CVA_LOOKUP = 'cva-lookup',
  CVA_SNOMED_CODES = 'cva-snomed-codes',
  CVA_PATIENT = 'cva-patient',
  CVA_PRACTITIONER = 'cva-practitioner',
  CVA_SLOTS = 'cva-slots',
  CVA_IMMUNIZATION = 'cva-immunization',
  CVA_MEDICATION_REQUEST = 'cva-medication-request',
  CVA_LAB_RESULTS = 'cva-lab-results'
}
